export default class {
    
    constructor (audit, form) {
        
        this.Data = null;    

        this.FileName = null;   

        this.TradePointDaxId = form.TradePoint ? form.TradePoint.DaxId : null;   

        this.CreatedDate = null;        

        this.Location  = null;

        this.ActivityId = audit.TemplateId;        

        this.CategoryId = null;        

        this.AuditType = audit.Type;
    }
}

